import SimpleTable from '@rsa-digital/evo-shared-components/components/Table/SimpleTable';
import { graphql } from 'gatsby';
import React from 'react';
import { processTable } from 'helpers/csTypeProcessors';
import { CsTable } from 'types/contentStack';

export type TableProps = CsTable & { html_id: string };

type TableBlockProps = {
  table: TableProps;
};

export const query = graphql`
  fragment TableBlock on cs__table {
    html_id
    header_row {
      has_empty_corner_cell
      corner_cell_column_span
      header_cells {
        heading_text
        column_span
      }
    }
    content_rows {
      content_row {
        cells {
          cell {
            content_rich_text
            column_span
            is_highlighted
          }
        }
      }
    }
  }
`;

const TableBlock: React.FC<TableBlockProps> = ({ table }) => (
  <SimpleTable id={table.html_id} {...processTable(table)} />
);

export default React.memo(TableBlock);
